export default __webpack_public_path__ + "static/media/HKUST-removebg-preview.f6b57a9a.png";